import { Injectable } from '@angular/core';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { Observable, from, of } from 'rxjs';
import { catchError, concatMap } from 'rxjs/operators';
import jwt_decode from 'jwt-decode';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private auth0: Auth0Service) {}

  // Get the access token from Auth0
  getAccessToken(): Observable<string | null> {
    return this.auth0.getAccessTokenSilently().pipe(
      catchError(() => of(null))
    );
  }

  // Login with Auth0
  login(): void {
    this.auth0.loginWithRedirect({
      authorizationParams: {
        connection: environment.auth0.connection
      }
    });
  }

  // Logout from Auth0
  logout(): void {
    this.auth0.logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  }

  // Check if the user is authenticated
  isAuthenticated(): Observable<boolean> {
    return this.auth0.isAuthenticated$;
  }

  // Get the user profile
  getUserProfile(): Observable<any> {
    return this.auth0.user$;
  }

  // Get user roles from the token
  getUserRoles(): Observable<string[]> {
    return this.getAccessToken().pipe(
      concatMap(token => {
        if (!token) {
          return of([]);
        }
        try {
          const decodedToken: any = jwt_decode(token);
          return of(decodedToken['https://curb-cloud.com/roles'] || []);
        } catch (error) {
          console.error('Error decoding token', error);
          return of([]);
        }
      })
    );
  }
}
